import {ErrorEventEntitiesState} from './error-event-entities.state';
import {errorEventEntitiesAdapter} from './error-event-entities.adapter';


export const errorEventEntitiesStateInitial: ErrorEventEntitiesState = errorEventEntitiesAdapter.getInitialState({
  loadLoading: [],
  loadLoaded: [],
});
